export default "__VITE_ASSET__BBOCEdXe__"